<template>
    <section class="sl-book">
        <div>Book an Appointment</div>

        {{ fittingType }}

        <div v-for="fitting in fittings" :key="fitting._uid">
            <div>{{ fitting.name }}</div>

            <div v-for="timeSlot in fitting.timeSlots" :key="timeSlot._uid">
                {{ timeSlot.available }}
                {{ timeSlot.startTime }} - {{ timeSlot.endTime }}
            </div>
        </div>
        <div class="form-block">
            <InputText v-model="form.golferFirstName" name="golferFirstName" label="First Name" :required="true" />
    
            <div class="invalid-feedback">
                { $constants.properties.PLEASEPROVIDEYOURFIRSTNAME }
            </div>
        </div>

        <div class="form-block">
            <InputText v-model="form.golferLastName" name="golferLastName" label="Last Name" :required="true" />
            <div class="invalid-feedback">
                { $constants.properties.PLEASEPROVIDEYOURLASTNAME }
            </div>
        </div>

        <div class="form-block">
            <InputText v-model="form.golferEmail" name="golferEmail" label="E-mail Address" type="email" :required="true" />
        </div>

        <div class="form-block">
            <InputText v-model="form.golferPhoneNumber" name="golferPhoneNumber" label="Phone Number" type="email" :required="true" :class="{'is-invalid': formErrors.phoneIsInvalid}" />
        </div>

        <div class="form-block">
            <InputSelect v-model="form.gender"
                         name="genderInput"
                         label="Gender"
                         :options="[
                             { label: 'Male', value: 'm'},
                             { label: 'Female', value: 'f'},
                         ]" />
        </div>
    </section>
</template>
<script>
import InputText from './InputText';
import InputSelect from './InputSelect';

export default {
    components: {
        InputText,
        InputSelect,
    },

    props: ['fittings'],

    data () {
        return {
            fittingType: null,
            form       : {
                golferFirstName  : null,
                golferLastName   : null,
                golferEmail      : null,
                golferPhoneNumber: null
            },
            formErrors          : {},
            showPhoneNumberField: true,
            phoneNumberRequired : true,
        };
    }
};
</script>

<style scoped>
.sl-book {
    border: solid 1px red;

}
.form-block {
    padding: 10px;
}
</style>